<template>
  <div class="modal-card">
    <header class="modal-card-head"> 
        <h4 class="modal-card-title" >
           Send Delivery Shipping List
          <span class="line-height required-label has-text-dark is-size-5 is-italic is-pulled-right mr-0 has-text-weight-normal">
            * required
          </span>
        </h4>
      </header>
      <section class="modal-card-body is-size-2 is-marginless shipping-delivery-col">
        <div class="columns">
          <div class="column">
            <div class="field mb-5">
              <div class="field-label">
                <label class="label is-italic has-text-weight-semibold">Delivery</label>
              </div>
              <div class="field-body">
                <span class="has-text-weight-normal">{{ rowData.name }}</span>
              </div>
            </div>
             <div class="field">
              <div class="field-label">
                <label class="label is-italic has-text-weight-semibold">Destination Project</label>
              </div>
              <div class="field-body">
                <span class="has-text-weight-normal">{{ $_.get(rowData, 'delivery.deliveryProject.name', '') }}</span>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <div class="field-label">
                    <label class="label is-italic has-text-weight-semibold">Ship Date</label>
                  </div>
                  <div class="field-body has-text-weight-normal">
                    <field-date 
                      :item="rowData" 
                      :input-props="{
                        kind: 'delivery.deliveryStart', 
                       }" 
                      :is-edit="false"></field-date>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <div class="field-label">
                    <label class="label is-italic has-text-weight-semibold">Delivery Date</label>
                  </div>
                  <div class="field-body has-text-weight-normal">
                   <field-date 
                      :item="rowData" 
                      :input-props="{
                        kind: 'delivery.deliverBy', 
                       }" 
                      :is-edit="false"></field-date>
                  </div>
                </div>
              </div>
            </div>
             <div class="field">
              <div class="field-label">
                <label class="label is-italic has-text-weight-semibold">Delivery Location</label>
              </div>
              <div class="field-body  has-text-weight-normal is-size-3">
                <span>{{ $_.get(rowData, 'delivery.deliveryLocation.name', '') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="is-divider my-0"></div>
        <div v-if="isBulk" class="card-edit-item-table has-background-white p-0 card-theme">
          <mf-detail-row
            :rowData="rowData"
            :users="users"
            :emails="emails"
            :refreshCard="loadCard"
            @tabName="setTabName"
            @saveCard="saveCard"
            :tabLabel="selectedTabName"
            :sendDeliveryShippingLists="true"
            :deliveries="deliveries"
            >
          </mf-detail-row>
        </div>
        <div v-else>
          <div class="field mt-2">
            <div class="columns">
              <div class="column">
                <label class="label is-italic has-text-weight-semibold">{{`Recipients * (${emails.length}/5)`}}</label>
              </div>
              <div class="column is-narrow">
                <button class="button is-size-3 is-outlined has-text-white"
                @click="clearAll()"
                :disabled="!emails.length" >Clear All</button>
              </div>
            </div>
            <div class="box">
              <div
                  class="button has-background-black-bis has-text-white taghover m-1 p-1"
                  v-for="(emp, idx) in emails"
                  :key="idx"
                  @click="removeExternalEmail(emp)"
                >
                  <span>{{ emp }}</span>
                  <i class="icon-close has-text-white"></i>
                </div>
            </div>
          </div>
          <div class="column">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <h4 class="is-size-3 is-italic">Add Manufacton Users</h4>
                 </div>
                    <search-bar class="mb-3"
                      :shouldEmit="true"
                      placeholder="Search"
                      @search="getSearchValue($event)"
                    />
                    <div v-for="(option, key) in getUserList" :key="key"  class="users-box">
                      <h3 class="is-italic
                          is-size-4
                          has-text-grey-dark
                          line-height">
                        {{ key }}
                    </h3>
                      <div v-for="user in option" :key="user.id">
                        <o-checkbox class="p-0 mb-1"
                          @update:modelValue="addUsers(user)"
                          v-model="user.checked"
                          :disabled="emails.length >= 5"
                          >
                          <span class="is-regular is-size-3 has-text-dark">
                            {{ user.name }}
                          </span>
                        </o-checkbox>
                      </div>
                    </div>
              </div>
              <div class="is-divider-vertical box-divider"></div> 
              <div class="column">
                <div class="field">
                  <h4 class="is-size-3 is-italic">Add Email Recipients</h4>
                  <div class="columns">
                    <div class="column pr-0">
                      <div class="field-body">
                        <div class="control  has-icons-left mb-2">
                          <input
                            class="input pl-1 border-color"
                            type="email"
                            v-model="emailInput"
                          />  
                        </div>
                      </div>
                    </div>
                    <div class="column is-narrow">
                      <button class="button has-background-black-bis has-text-white p-0" @click="addExternalEmail()">
                        <i class="icon-addnew"></i>
                      </button>
                    </div>
                  </div>  
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot is-justify-content-flex-end">
        <button class="button is-outlined" @click="cancel()">Cancel</button>
        <button
          class="button has-background-black-bis"
          @click="sendShippingList()"
          :disabled="isBulk ? (!emails.length || !deliveries.length) : !emails.length"
        >Send Shipping List</button>
      </footer>
  </div>
  <o-loading :active="isLoading" :full-page="false" :can-cancel="true"/>
</template>



<script>
  import { computed, inject, onBeforeMount, reactive, toRefs } from 'vue';
  import { useStore } from 'vuex';
  import Validate from '@/components/utils/Validations';
  import { useToast } from 'vue-toastification';
  import SearchBar from '@/components/SearchBar.vue';
  import Projects from '@/models/Projects';
  import GeneralShippingMixin from '@/components/mixins/GeneralShippingMixin';
  import MfDetailRow from '@/components/table-fields/MfDetailRow.vue';
 

  export default ({
    name: 'SendDeliveryShippingList',
    components: {
      'search-bar': SearchBar,
      'mf-detail-row': MfDetailRow,
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      isBulk: {
        type: Boolean,
        default: false
      }
    },

    setup(props, {emit}) {
      const emitter = inject('emitter');
      const toast = useToast();
      const store = useStore();
      const data = reactive({
        emails: [],
        emailInput: '',
        users: [],
        isLoading: false,
        searchText: '',
        deliveries: [],
      });
      const {updateShipment} = GeneralShippingMixin();

      const getUserList = computed(() => {
        let list = {};
        for(const company in data.users) {
          const obj = data.users[company].filter((usr) => {
            if (usr.name.toLowerCase().includes(data.searchText.toLowerCase())) {
              return true;
            }
          })
          list[company] = obj;
        }
        return list;
      })

      const getSearchValue = (val) => {
       data.searchText = val;
      }
      
      const  setUserChecked = (user, val) => {
        for(const company in data.users) {
          data.users[company].forEach((usr) => {
            if (usr.email ===  user.email) {
              usr.checked = val;
            }
        })
       }
      }

      const addEmail = (email) => {
        let toastErrorMessage = '';
        if(data.emails.length >= 5) return toast.error('Maximum of 5 emails allowed');

        const isEmailValid = Validate.validateEmail(email);
        if (!isEmailValid) toastErrorMessage = 'Please Enter Valid Email';

        const isEmailExisting = data.emails.includes(email);
        if (isEmailExisting) toastErrorMessage = 'Email Already Present';

        setUserChecked({email: email}, true);

        if (toastErrorMessage) {
          toast.error(toastErrorMessage);
          return;
        }

        data.emails.push(email);
      }

      const addUsers = (user) => {
        if(data.emails.length >= 5){
          setUserChecked(user, false);
          return toast.error('Maximum of 5 emails allowed');  
        }
        if(!data.emails.includes(user.email)) {
          addEmail(user.email);
        } else {
          setUserChecked(user, false);
          data.emails = data.emails.filter((e) => e !== user.email);
        }
      }

      const addExternalEmail = () => {
        addEmail(data.emailInput);
        data.emailInput = '';
      }

      const removeExternalEmail = (email) => {
        data.emails = data.emails.filter((e) => e !== email);
        setUserChecked({email: email}, false);
      }

      emitter.on('emails', (payload) => {
        data.emails = payload;
      })

      emitter.on('deliveriesList', (payload) => {
        data.deliveries = payload;
      })

      const fetchUsers = async (pId) => {
        const allUsers = await Projects.linkedProjectUsers([pId]);
        const users = _.filter(allUsers, (usr) => usr.company === _.get(store.state.userData, 'company._id', store.state.userData.company));
        return users;
      };

      const cancel = () => {
        emit('close', false);
        emit('refresh-card');
      };

      onBeforeMount(async () => {
       if(_.isEmpty(props.rowData)) return;
       data.isLoading = true;
       data.users = _.groupBy(await fetchUsers(_.get(props.rowData, 'delivery.currentProject._id')), 'companyName');
       data.isLoading = false;
      });

      const sendShippingList = async () => {
        try {
          data.isLoading = true;
          if (props.isBulk) {
            for (let delivery of data.deliveries) {
              _.set(delivery, 'externalEmails', data.emails);
              await updateShipment(delivery);
            }
          } else {
            _.set(props.rowData, 'externalEmails', data.emails);
            await updateShipment(props.rowData);
          }
        } catch (err) {
          console.log(err);
        } finally {
          data.isLoading = false;
        }
        cancel();
      }

      const clearAll = () => {
        data.emails = [];
        for(const company in data.users) {
          data.users[company].forEach((usr) => {
            usr.checked = false;
          })
        }
      }


      return {
        ...toRefs(data),
        addExternalEmail,
        removeExternalEmail,
        getSearchValue,
        sendShippingList,
        cancel,
        addUsers,
        clearAll,
        getUserList
      }
    }
  })
</script>

<style scoped>
.modal-card-head {
  background-color: #fff !important;
  border-bottom: none !important;
}
</style>